export const GET_NUTRITION_PREFERENCES = "nutrition-preference/GET_NUTRITION_PREFERENCES";
export const GET_NUTRITION_PREFERENCES_SUCCESS = "nutrition-preference/GET_NUTRITION_PREFERENCES_SUCCESS";
export const GET_NUTRITION_PREFERENCES_ERROR = "nutrition-preference/GET_NUTRITION_PREFERENCES_ERROR";

export const UPDATE_NUTRITION_PREFERENCES = "nutrition-preference/UPDATE_NUTRITION_PREFERENCES";
export const UPDATE_NUTRITION_PREFERENCES_SUCCESS = "nutrition-preference/UPDATE_NUTRITION_PREFERENCES_SUCCESS";
export const UPDATE_NUTRITION_PREFERENCES_ERROR = "nutrition-preference/UPDATE_NUTRITION_PREFERENCES_ERROR";